import { api } from "../api/requests";

//get payout metrics
export async function getPayoutMetrics(brokerId?: number, dateFrom?: string, dateTo?: string, insurerId?: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/payouts/metrics?${brokerId ? `brokerId=${brokerId}` : ''}${dateFrom ? `&dateFrom=${dateFrom}` : ''}${dateTo ? `&dateTo=${dateTo}` : ''}${insurerId ? `&insurerId=${insurerId}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}
